var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FiltersAside',{class:_vm.baseClass,attrs:{"filters":_vm.filters,"messages":_vm.messages},on:{"accept":_vm.accept}})
}
var staticRenderFns = []

export { render, staticRenderFns }